class NSSMegaNav extends HTMLElement {
  constructor() {
    super();

    this.debug = false;

    this.overlayEl = document.querySelector(`nss-overlay`);
    this.overlayDetails = {
      element: `nss-mega-nav`,
      zIndex:
        getComputedStyle(document.documentElement).getPropertyValue(`--nss-z-index-header-group`) -
        1,
    };
  }

  connectedCallback() {
    if (this.debug) console.log(`[NSS][Mega Nav] Connected.`);

    this.initCarouselNav();

    this.addEventListener("openMegaNav", (e) => {
      this.setAttribute(`nss-mega-nav-open`, true);

      /**
       * If this is disabled, the subnav for both desktop and mobile will not
       * open.
       */
      this.openItem(e.detail);

      const event = new CustomEvent("registerOverlay", {
        detail: this.overlayDetails,
      });
      this.overlayEl.dispatchEvent(event);
    });

    this.addEventListener("overlayClosed", this.closeMegaNav, false);
    this.addEventListener("closeMegaNav", this.closeMegaNav, false);

    const subNavBtnEls = this.querySelectorAll(
      `.nss-mega-nav-products__button-d[nss-mega-sub-nav-id]`
    );
    subNavBtnEls.forEach((subNavBtnEl) => {
      subNavBtnEl.addEventListener("mouseenter", (e) => {
        if (this.debug) console.log(`[NSS][Mega Nav] Mouse entered e.target:`, e.target);
        const subNavId = e.target.getAttribute(`nss-mega-sub-nav-id`);
        this.openSubNav(subNavId);
      });
    });

    this.addEventListener("mouseleave", (e) => {
      let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
      if (vw >= 990 && !Shopify.designMode) {
        this.closeMegaNav();
      }
    });

    let mobileSelectors = `.nss-mega-nav-products__button-m[nss-menu-id], .nss-link-nav[nss-menu-id]`;
    const menuBtnEls = this.querySelectorAll(mobileSelectors);
    menuBtnEls.forEach((menuBtnEl) => {
      menuBtnEl.addEventListener("click", (e) => {
        if (this.debug) console.log(`[NSS][Mega Nav] e.target:`, e.target);
        const status = e.target.getAttribute(`nss-menu-open`);
        if (this.debug) console.log(`[NSS][Mega Nav] [nss-menu-open] status:`, status);

        if (status === "true") {
          if (this.debug) console.log(`[NSS][Mega Nav] Already open, closing all.`);
          this.closeAllMenus();
        } else {
          if (this.debug) console.log(`[NSS][Mega Nav] Not already open, closing all and opening.`);
          this.closeAllMenus();
          const menuId = e.target.getAttribute(`nss-menu-id`);
          const menuEls = this.querySelectorAll(`[nss-menu-id="${menuId}"]`);
          menuEls.forEach((menuEl) => {
            menuEl.setAttribute(`nss-menu-open`, true);
            menuEl.setAttribute(`nss-mega-sub-nav-open-m`, true);
          });
        }
      });
    });

    // const yotpoCheckId = setInterval(() => {
    //   if (this.querySelector(`.standalone-bottomline`)) {
    //     clearInterval(yotpoCheckId);
    //     this.removeYotpoTabs();
    //   }
    // }, 500);

    const editorEvents = [
      `shopify:inspector:activate`,
      `shopify:inspector:deactivate`,
      `shopify:section:load`,
      `shopify:section:unload`,
      `shopify:section:select`,
      `shopify:section:deselect`,
      `shopify:section:reorder`,
      `shopify:block:select`,
      `shopify:block:deselect`,
    ];
    editorEvents.forEach((event) => {
      this.addEventListener(event, this.handleEditorEvent.bind(this));
    });
  }

  removeYotpoTabs() {
    const tabEls = this.querySelectorAll(`.nss-reviews [tabindex]`);
    tabEls.forEach((tabEl) => {
      tabEl.removeAttribute(`tabindex`);
    });
  }

  handleEditorEvent(e) {
    if (this.debug) console.log("[NSS][Mega Nav] Handle editor event, e:", e);

    switch (e.type) {
      case `shopify:block:deselect`:
        this.closeMegaNav();
        break;

      case `shopify:block:select`:
        if (this.debug) console.log("[NSS][Mega Nav] Block selected...");
        const itemEl = e.target.closest(`nss-mega-nav-item`);
        const itemId = itemEl.getAttribute(`nss-mega-nav-item-id`);
        const megaNavEl = document.querySelector(`nss-mega-nav`);
        const event = new CustomEvent("openMegaNav", { detail: itemId });
        megaNavEl.dispatchEvent(event);
        const subNavEl = e.target.closest(`[nss-mega-sub-nav-id]`);
        if (subNavEl) {
          const subNavId = subNavEl.getAttribute(`nss-mega-sub-nav-id`);
          if (this.debug) console.log("[NSS][Mega Nav] Block subNavId:", subNavId);
          this.openSubNav(subNavId);
        }
        const menuEl = e.target.closest(`[nss-menu-id]`);
        if (menuEl) {
          const menuId = menuEl.getAttribute(`nss-menu-id`);
          if (this.debug) console.log("[NSS][Mega Nav] Block menuId:", menuId);
          this.openMenu(menuId);
        }
        break;
    }
  }

  openItem(id) {
    this.closeAllItems();
    let itemEl;
    if (id) {
      itemEl = this.querySelector(`[nss-mega-nav-item-id="${id}"]`);
      if (!itemEl) {
        console.warn(
          `[NSS][Mega Nav] Item id '${id}' not found, falling back to first item. Ensure the block exists and the name matches in the customizer.`
        );
      }
    }
    if (!itemEl) {
      itemEl = this.querySelectorAll(`[nss-mega-nav-item-id]`)[0];
    }
    if (itemEl) {
      /**
       * Default-open the first sub nav that actually has a desktop panel: rail
       * entries that are plain links (rail_link_url) carry no
       * [nss-mega-sub-nav-id] on their desktop element, and hidden rail
       * buttons are skipped, so one panel is always visible.
       */
      const railBtnEls = itemEl.querySelectorAll(
        `.nss-mega-nav-products__button-d[nss-mega-sub-nav-id]`
      );
      const firstSubNavEl =
        Array.from(railBtnEls).find((el) => el.style.display !== `none`) ||
        itemEl.querySelectorAll(`[nss-mega-sub-nav-id]`)[0];
      if (firstSubNavEl) {
        const subNavId = firstSubNavEl.getAttribute(`nss-mega-sub-nav-id`);
        if (this.debug) console.log(`[NSS][Mega Nav] subNavId:`, subNavId);
        this.openSubNav(subNavId);
      }
      itemEl.setAttribute(`nss-mega-nav-item-open`, true);
    } else {
      console.error(
        `[NSS][Mega Nav] Couldn't find item id. Ensure that the block exists and the name matches in the customizer.`
      );
    }
  }

  openSubNav(id) {
    this.closeAllSubNavs();
    const subNavEls = this.querySelectorAll(`[nss-mega-sub-nav-id="${id}"]`);
    subNavEls.forEach((subNavEl) => {
      subNavEl.setAttribute(`nss-mega-sub-nav-open-d`, true);

      /**
       * For future reference, these two lines here control whether the first
       * subnav item is open when the overall menu is opened on mobile. Should
       * make this into a configurable setting in the future (TODO).
       */
      // subNavEl.setAttribute(`nss-menu-open`, true);
      // subNavEl.setAttribute(`nss-mega-sub-nav-open-m`, true);
    });
  }

  openMenu(id) {
    this.closeAllMenus();
    const menuEls = this.querySelectorAll(`[nss-menu-id="${id}"]`);
    menuEls.forEach((menuEl) => {
      menuEl.setAttribute(`nss-menu-open`, true);
      menuEl.setAttribute(`nss-mega-sub-nav-open-m`, true);
    });
  }

  closeAllMenus() {
    const menuEls = this.querySelectorAll(`[nss-menu-open="true"]`);
    menuEls.forEach((menuEl) => {
      menuEl.setAttribute(`nss-menu-open`, false);
      menuEl.setAttribute(`nss-mega-sub-nav-open-m`, false);
    });
  }

  closeAllSubNavs() {
    const subNavEls = this.querySelectorAll(`[nss-mega-sub-nav-open-d="true"]`);
    subNavEls.forEach((subNavEl) => {
      subNavEl.setAttribute(`nss-mega-sub-nav-open-d`, false);
    });
  }

  closeAllItems() {
    const itemEls = this.querySelectorAll(`nss-mega-nav-item`);
    itemEls.forEach((itemEl) => {
      itemEl.setAttribute(`nss-mega-nav-item-open`, false);
      this.closeAllSubNavs();
    });
  }

  megaNavClosedEvent() {
    const headerEl = document.querySelector(`nss-header`);
    const event = new CustomEvent("megaNavClosed");
    headerEl.dispatchEvent(event);
  }

  initCarouselNav() {
    const rows = this.querySelectorAll(`.nss-mega-nav-products__wrapper--carousel`);

    rows.forEach((row) => {
      row.addEventListener(
        `wheel`,
        (e) => {
          if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;
          if (row.scrollWidth <= row.clientWidth) return;
          const atStart = row.scrollLeft <= 0;
          const atEnd = row.scrollLeft + row.clientWidth >= row.scrollWidth - 1;
          if ((e.deltaY < 0 && atStart) || (e.deltaY > 0 && atEnd)) return;
          e.preventDefault();
          row.scrollLeft += e.deltaY;
        },
        { passive: false }
      );

      let down = false;
      let startX = 0;
      let startScroll = 0;
      let moved = 0;

      row.addEventListener(`pointerdown`, (e) => {
        if (e.pointerType === `touch`) return;
        down = true;
        moved = 0;
        startX = e.clientX;
        startScroll = row.scrollLeft;
      });

      row.addEventListener(`pointermove`, (e) => {
        if (!down) return;
        const dx = e.clientX - startX;
        moved = Math.max(moved, Math.abs(dx));
        if (moved > 3) {
          row.setPointerCapture(e.pointerId);
          row.style.cursor = `grabbing`;
          row.style.scrollSnapType = `none`;
          row.scrollLeft = startScroll - dx;
        }
      });

      const endDrag = (e) => {
        if (!down) return;
        down = false;
        row.style.cursor = ``;
        row.style.scrollSnapType = ``;
        if (moved > 3 && e.target.closest(`a`)) {
          const swallow = (ev) => {
            ev.preventDefault();
            ev.stopPropagation();
          };
          row.addEventListener(`click`, swallow, { capture: true, once: true });
        }
      };

      row.addEventListener(`pointerup`, endDrag);
      row.addEventListener(`pointercancel`, endDrag);
      row.addEventListener(`pointerleave`, endDrag);
    });
  }

  closeMegaNav() {
    if (this.debug) console.log(`[NSS][Mega Nav] Closing!`);
    this.setAttribute(`nss-mega-nav-open`, false);
    this.closeAllItems();
    this.closeAllSubNavs();
    this.closeAllMenus();
    this.megaNavClosedEvent();
    const event = new CustomEvent("unregisterOverlay", {
      detail: this.overlayDetails,
    });
    this.overlayEl.dispatchEvent(event);
  }
}

let elementName = `nss-mega-nav`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSSMegaNav);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`);
}
